import { createSelector } from '@ngrx/store';
import find from 'lodash/find';

import { ICitation } from '../../models';
import { getCitation } from './get.citations';
import { getNumberedCitations } from './get.numbered.citations';

const getDeletedCitationID = createSelector(
  [getCitation],
  (state): string => state.deletedCitationFromRHP
);

export const getDeletedCitationFromRHP = createSelector(
  [getDeletedCitationID, getNumberedCitations],
  (id, references: ICitation[]): ICitation | undefined =>
    id && find(references, { citationId: id })
);
